<template>
  <div class="outter">
    <span class="inner">
      You can hide a Secret Image into a Host Image, and get a Container Image as result. <br>
      The difference between Host Image and Container Image invisible for human eyes. <br>
      You can also extract the Secret Image from the Container Image through this website.<br>
      Due to computing performance limitation, the image's total pixel number need to less than 800*600, otherwise it will be compressed.<br>
      <br>
      Instruction:<br><br>
       Hide:<br>
        1. Upload host and secret images.<br>
        2. Select which one is host or secret image.<br>
        3. Click Hide.<br>
        4. Wait 1 min to get your result container image.<br>
        <br>
       Extract:<br>
        1. Upload container image.<br>
        2. Select which one is container image.<br>
        3. Click Extract.<br>
        4. Wait 1 min to get your result extracted image.<br>
  
    </span>
  </div>
</template>

<script>

export default {
  name: "Info",
  components:{
  },
  data(){
    return {
    
    test:'test',
  }},
  provide(){
    console.log(this.modelID)
    return{modelID: this.modelID}
  }
}
</script>

<style scoped>
.outter {
  text-align: left;
  width: 100%;
  margin: 10px auto;
  padding: 10px;
  display: flex;
  justify-content: center;
}
.inner {
  padding: 10px;
  background-color: #40a0ff2d;
  border-radius: 10px;
  border-left: #409eff 10px solid;
  padding: 10px;
}
.example{
  background: red;
  width:50%;
}
</style>